import type { TrainingLessonSpecific } from './trainingLessonUi';

export const core4OrdinancesEn: TrainingLessonSpecific = {
  intro:
    'Ordinances are sacred acts authorized by the priesthood and tied to covenants. Spiritual preparation and reverence invite the Spirit and draw us to Christ.',
  objectives: [
    'Understand what an ordinance is and why it is sacred.',
    'Differentiate ordinances from traditions.',
    'Understand personal preparation (repentance, faith, dignity).',
    'Learn how to prepare for the sacrament as covenant renewal.',
    'Identify habits of reverence and order that invite the Spirit.',
  ],
  briefHeading: 'Ordinances and covenants: power, purity, and renewal',
  briefBody:
    'Ordinances require priesthood authority, meaningful symbols, and covenants with God. They are not routine: they are commitments that bring us to Christ and help us have His Spirit. The sacrament renews those covenants each week.',
  scriptures: [
    { ref: 'D&C 20:77, 79', text: 'That they may always have his Spirit to be with them.' },
    { ref: '3 Nephi 18:28–29', text: '…ye shall not suffer any one knowingly to partake of my flesh and blood unworthily…' },
    { ref: 'Moroni 4–5', text: 'The sacrament: remember the Savior and renew covenants.' },
    { ref: 'John 3:5', text: 'Except a man be born of water and of the Spirit, he cannot enter into the kingdom of God.' },
    { ref: 'Mosiah 18:8–10', text: 'Willing to bear one another’s burdens...' },
  ],
  didYouKnow: [
    'Ordinances combine symbol + covenant + authority: not routine, but covenant.',
    'Reverence is not “looking serious”: it makes room for the Spirit.',
  ],
  practiceItems: [
    'Explain in one sentence what an ordinance is',
    'Before sacrament: list two things you will do (reverence + focus)',
    'Review your week: one thing to repent of or adjust (practical, not dramatic)',
    'Read D&C 20:77/79 and write one keyword (“remember,” “Spirit,” etc.)',
    'Arrive 10 minutes early on Sunday and avoid distractions (phone/chat)',
    'Do one reverent act: listen, serve, or help someone else prepare',
  ],
  reflectionQuestions: [
    'What distracts me most during ordinances, and how will I fix it?',
    'Which covenant do I need to remember more intentionally?',
    'What will I do differently this Sunday to invite the Spirit?',
  ],
  actionText:
    'Sacrament with intention: choose one concrete habit (arrive early, prepare scriptures, pray beforehand) and keep it for two Sundays in a row.',
};
